"use client";

import { cn } from "@/lib/utils";
import { ReactNode, useEffect, useId, useState } from "react";
import { LoaderIcon } from "lucide-react";

export const ImageHoverWrapper = ({
  className,
  children,
  rounded,
  isGroup = true,
  hideSpinner = false,
}: {
  className?: string;
  children: ReactNode;
  rounded: string;
  isGroup?: boolean;
  hideSpinner?: boolean;
}) => {
  const id = useId();
  const [isClicked, setIsClicked] = useState(false);
  const eventName = "image-hover-wrapper-card-clicked";

  useEffect(() => {
    if (isClicked) {
      const event = new CustomEvent(eventName, {
        detail: {
          id,
        },
      });
      dispatchEvent(event);
    }
  }, [isClicked]);

  useEffect(() => {
    function cleanStatus(event: { detail: { id: string } }) {
      const {
        detail: { id: eventId },
      } = event;
      if (eventId !== id) {
        setIsClicked(false);
      }
    }
    window.addEventListener(eventName, cleanStatus);

    return () => {
      window.removeEventListener(eventName, cleanStatus);
    };
  }, []);

  return (
    <div
      className={cn(
        "relative overflow-hidden",
        className,
        rounded,
        isGroup && "group",
      )}
      onClick={() => setIsClicked(true)}
    >
      <div className="pointer-events-none absolute inset-0 -bottom-4 z-1 bg-gradient-to-t from-black/30 to-white/10 opacity-0 transition-opacity duration-500 group-hover:bottom-0 group-hover:opacity-100" />
      <div className={cn(rounded, "overflow-hidden transition-all")}>
        {children}
      </div>
      {!hideSpinner && isClicked && (
        <div
          className={cn(
            "pointer-events-none absolute inset-0 z-2 flex items-center justify-center bg-black/70 text-white backdrop-blur-[2px] transition-all",
            rounded,
          )}
        >
          <LoaderIcon size={16} className={"animate-spin"} />
        </div>
      )}
    </div>
  );
};
